import { RecordCircleIcon } from "@vericus/cadmus-icons";
import { Button, colors } from "@vericus/cadmus-ui";

type Props = {
  disabled?: boolean;
  onPress?: () => void;
  numAttemptsRemaining: number;
};

export function ReattemptButton({
  disabled,
  onPress,
  numAttemptsRemaining,
}: Props) {
  const isDisabled = disabled === true || numAttemptsRemaining === 0;

  return (
    <Button
      kind="outline"
      icon={
        <RecordCircleIcon
          label=""
          size={24}
          color={isDisabled ? colors.sgrey400 : colors.poppy700}
        />
      }
      onClick={onPress}
      disabled={isDisabled}
    >
      {`RE-ATTEMPT (${numAttemptsRemaining} LEFT)`}
    </Button>
  );
}
